import mirror from 'keymirror';

export const actionTypes = mirror({
  SESSION_RESET_LENGTH: null,
  SESSION_SET_LENGTH: null,
  SESSION_UPDATE: null,
});

const sessionSetLength = mins => ({
  mins,
  type: actionTypes.SESSION_SET_LENGTH,
});

const sessionResetLength = () => ({
  type: actionTypes.SESSION_RESET_LENGTH,
});

const sessionUpdate = data => ({
  data,
  type: actionTypes.SESSION_UPDATE,
});

export function setSessionLength(mins) {
  return async dispatch => {
    dispatch(sessionSetLength(mins));
  };
}

export function resetSessionLength() {
  return async dispatch => {
    dispatch(sessionResetLength());
  };
}

export function updateSession(data) {
  return async dispatch => {
    dispatch(sessionUpdate(data));
  };
}
